import { makeStyles, Theme } from "@material-ui/core/styles";

const border = '1px solid #cccccc';
const styles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  title: {
    fontSize: 23,
    fontWeight: 'bold',
    textTransform: 'none',
  },
  subtitle: {
    fontSize: 17,
    fontWeight: 'bold',
    marginTop: 13,
    marginBottom: 10,
  },
  info: {
    color: 'grey',
    textTransform: 'none',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  translationsContainer: {
    height: 300,
    width: '100%',
    overflowY: 'auto',
    marginTop: 13,
    border,
  },
  containerAppBar: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.subMenusColor.main,
    verticalAlign: 'middle',
    position: 'relative',
  },
  containerTitle: {
    color: 'white',
    fontSize: 20,
    marginLeft: 10,
    paddingTop: 5,
  },
  holdingProfilesContainer: {
    position: 'relative',
    width: '100%',
    border,
    height: 'auto',
    marginTop: 20,
  },
  translationItem: {
    paddingLeft: 40,
    color: 'grey',
    textTransform: 'none',
  },
  containerTitleButton: {
    position: 'absolute',
    right: 0,
    top: -5,
    color: 'white',
  },
  holdingProfilesContainerMenuItem: {
    width: '100%',
    border,
    height: 'auto',
    marginTop: 20,
  },
  addMore: {
    position: 'absolute',
    top: 2,
    right: 5,
    fontSize: 20,
  },

  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    textTransform: 'none',
    height: 35,
    fontSize: 12,
  },
  tabSelected: {
    textTransform: 'none',
    height: 35,
    fontSize: 12,
    backgroundColor: '#ededed',
  },
  formControl: {
    padding: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  disabled: {
    pointerEvents: 'none',
  },
  separation: {
    marginTop: 10,
    marginBottom: 10,
  },
  formButton: {
    margin: theme.spacing(1),
  },
  formControlSelects: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  attributeItem: {
    display: 'flex',
    flexBasis: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '.5em',
    '& P': {
      marginLeft: '.5em',
    },
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  flexSpaceAround: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  flexStart: {
    display: 'flex',
    justifyContent: 'start',
  },
}));

export default styles;
